export function getClassNames(scheme: 'sky' | 'white' | 'purple'): { bg: string; checkmarkColor: string } {
  switch (scheme) {
    case 'sky':
      return {
        bg: 'bg-gradient-sky',
        checkmarkColor: 'text-white',
      }

    case 'white':
      return {
        bg: 'bg-white',
        checkmarkColor: 'text-green-dark',
      }

    case 'purple':
      return {
        bg: 'bg-gradient-purple-dark-top',
        checkmarkColor: 'text-white',
      }

    default:
      return {
        bg: '',
        checkmarkColor: '',
      }
  }
}
